/**
 * Editor Schema for QRLand Games
 * نسخه نهایی – ۱۰۰٪ منطبق با کد Vue دو بازی (Game و MeepMeepProRunner)
 */

export const editorSchema = {
  Game: {
    texts: true,
    images: true,
    config: true,
    login: true, // Added login settings

    imagesConfig: {
      bgMain: { type: "image", label: "تصویر پس‌زمینه اصلی بازی" },
      bgModal: { type: "image", label: "تصویر پس‌زمینه مودال‌ها" },
      player: { type: "image", label: "کاراکتر اصلی (عادی)" },
      playerHappy: { type: "image", label: "کاراکتر (خوشحال)" },
      playerSad: { type: "image", label: "کاراکتر (غمگین)" },
      magnet: { type: "image", label: "آیکون آهنربا" },
      qrs: { type: "imageArray", label: "تصاویر QRها" },
      traps: { type: "imageArray", label: "تصاویر موانع" },
      phoneFrameBackground: { type: "image", label: "تصویر پس‌زمینه فریم تلفن" },
    },

    textsConfig: {
      gameTitle: { type: "text", label: "عنوان بازی" },
      tutorialTitle: { type: "text", label: "عنوان راهنما" },
      tutorialSteps: { type: "array", label: "مراحل راهنما (۴ مورد)" },
      tutorialBtn: { type: "text", label: "متن دکمه فهمیدم" },
      scoreLabel: { type: "text", label: "برچسب امتیاز" },
      magnetLabel: { type: "text", label: "متن فعال‌سازی آهنربا" },
      winMsg: { type: "text", label: "پیام پیروزی" },
      failMsg: { type: "text", label: "پیام اتمام جان" },
      startBtn: { type: "text", label: "دکمه شروع" },
      submitBtn: { type: "text", label: "دکمه ثبت رکورد" },
      restartBtn: { type: "text", label: "دکمه تلاش مجدد" },
      phoneTitle: { type: "text", label: "عنوان فرم شماره" },
      phonePlaceholder: { type: "text", label: "Placeholder شماره" },
      confirmBtn: { type: "text", label: "دکمه تایید نهایی" },
      backBtn: { type: "text", label: "متن دکمه بازگشت (فرم شماره)" }, // ← مهم: اضافه شد
    },

    configConfig: {
      initialLives: { type: "number", label: "تعداد جان‌ها" },
      pointsPerQR: { type: "number", label: "امتیاز هر اسکن" },
      magnetThreshold: { type: "number", label: "حد نصاب آهنربا" },
      magnetDuration: { type: "number", label: "مدت آهنربا (میلی‌ثانیه)" },
      spawnRateEnemy: { type: "number", label: "فاصله تولید موانع (فریم)" },
      spawnRateQR: { type: "number", label: "فاصله تولید QRها (فریم)" },
      minSpeed: { type: "number", label: "حداقل سرعت اشیاء" },
      maxSpeed: { type: "number", label: "حداکثر سرعت اشیاء" },
    },

    loginConfig: {
      requirePhoneNumber: { type: "boolean", label: "نیاز به شماره موبایل" },
      phoneValidationPattern: { type: "text", label: "الگوی اعتبارسنجی شماره" },
      enableEmail: { type: "boolean", label: "فعال‌سازی ورود با ایمیل" },
      enableSocialLogin: { type: "boolean", label: "فعال‌سازی ورود اجتماعی" },
      askPhone: { type: "boolean", label: "پرسش شماره پس از بازی" },
      promptText: { type: "text", label: "متن درخواست شماره" },
      submitText: { type: "text", label: "متن دکمه ثبت" },
      logoUrl: { type: "image", label: "لوگوی فرم ورود" },
    },
  },

  MeepMeepProRunner: {
    texts: true,
    images: true,
    gameplay: true,
    colors: true,
    login: true, // Added login settings

    colorsConfig: {
      background: { type: "color", label: "رنگ پس‌زمینه / آسمان" },
      ground: { type: "color", label: "رنگ زمین / جاده" },
      hud: { type: "color", label: "رنگ باکس HUD و امتیاز" },
      particleHit: { type: "color", label: "رنگ ذرات برخورد / انفجار" },
      // accent حذف شد چون در Vue استفاده نمی‌شود
    },

    imagesConfig: {
      player: { type: "image", label: "تصویر کاراکتر دونده" },
      hero: { type: "image", label: "تصویر بزرگ هیرو (منوها)" },
      bgFar: { type: "image", label: "لایه پس‌زمینه دور" },
      bgNear: { type: "image", label: "لایه پس‌زمینه نزدیک" },
      traps: { type: "imageArray", label: "تصاویر موانع" },
      phoneFrameBackground: { type: "image", label: "تصویر پس‌زمینه فریم تلفن" },
    },

    textsConfig: {
      title: { type: "text", label: "عنوان اصلی بازی" },
      subtitle: { type: "text", label: "زیرعنوان شروع" },
      scoreLabel: { type: "text", label: "متن امتیاز" },
      levelLabel: { type: "text", label: "متن مرحله" },
      comboLabel: { type: "text", label: "متن کومبو" },
      startBtn: { type: "text", label: "متن دکمه شروع" },
      helpBtn: { type: "text", label: "متن دکمه راهنما" },
      gameOver: { type: "text", label: "تیتر پایان بازی" },
      newRecordMessage: { type: "text", label: "پیام رکورد جدید" },
      finalScore: { type: "text", label: "متن امتیاز نهایی" },
      maxCombo: { type: "text", label: "متن بیشترین کومبو" },
      restartBtn: { type: "text", label: "متن دکمه دوباره" },
      rewardBtn: { type: "text", label: "متن دکمه جایزه" },
      submitScore: { type: "text", label: "عنوان فرم ثبت امتیاز" },
      phonePrompt: { type: "text", label: "توضیح فرم شماره" },
      phonePlaceholder: { type: "text", label: "Placeholder شماره" },
      submitting: { type: "text", label: "متن در حال ثبت" },
      submitAndRestart: { type: "text", label: "متن ثبت و شروع دوباره" },
      cancel: { type: "text", label: "متن انصراف" },
      howToPlay: { type: "text", label: "عنوان راهنما" },
      closeHelp: { type: "text", label: "متن بستن راهنما" },
      helpContent: { type: "html", label: "محتوای راهنمای بازی (HTML)" },
      // funMessages:    { type: "array", label: "پیام‌های تشویقی" }  ← اگر فعلاً استفاده نمی‌شود، کامنت نگه دار
    },

    gameplayConfig: {
      lanesCount: { type: "number", label: "تعداد لاین‌ها" },
      baseSpeed: { type: "number", label: "سرعت اولیه" },
      maxSpeed: { type: "number", label: "حداکثر سرعت" },
      speedStep: { type: "number", label: "افزایش سرعت هر مرحله" },
      jumpForce: { type: "number", label: "قدرت پرش (منفی)" },
      gravity: { type: "number", label: "نیروی جاذبه" },
      minScoreToSubmit: {
        type: "number",
        label: "حداقل امتیاز برای فرم جایزه",
      },
    },

    loginConfig: {
      requirePhoneNumber: { type: "boolean", label: "نیاز به شماره موبایل" },
      phoneValidationPattern: { type: "text", label: "الگوی اعتبارسنجی شماره" },
      enableEmail: { type: "boolean", label: "فعال‌سازی ورود با ایمیل" },
      enableSocialLogin: { type: "boolean", label: "فعال‌سازی ورود اجتماعی" },
      askPhone: { type: "boolean", label: "پرسش شماره پس از بازی" },
      promptText: { type: "text", label: "متن درخواست شماره" },
      submitText: { type: "text", label: "متن دکمه ثبت" },
      logoUrl: { type: "image", label: "لوگوی فرم ورود" },
    },
  },
};
